import Vue from 'vue'
import Vuex from 'vuex'
import Vue2TouchEvents from 'vue2-touch-events'
import VueObserveVisibility from 'vue-observe-visibility'
import WayfinderVueComponents from '@3dwayfinder/wayfinder-vue-components';
import { loadWayfinder } from '@3dwayfinder/wayfinder-vue-components';


import App from './App.vue'
import './registerServiceWorker'

Vue.use(Vuex);
Vue.use(VueObserveVisibility);
Vue.use(Vue2TouchEvents, {tapTolerance: 15, 
	touchHoldTolerance: 600,
  swipeTolerance: 100,
  longTapTimeInterval: 600,
	touchClass: 'wf-touch'
});

Vue.config.productionTip = false

const WF_MAP_TYPE = "3d2";
const WF_PROJECT = "f99ca120099f13c3d57d9d9998fd6cfb";
const WF_API = "live";

const store = new Vuex.Store({
	state: {
		appName: "Wayfinder Vue Components",
		currentPOI: null,
		currentGroup: null,
		defaultGroup: null,
		searchVisible: false,
		currentTab: "groups",
		activities: [],
		log: []
	},
	mutations: {
		setPOI (state, poi) {
			state.currentPOI = poi;
		},
		setGroup (state, group ) {
			state.currentGroup = group;
		},
		setDefaultGroup (state, group ) {
			state.defaultGroup = group;
		},
		showSearch (state, show) {
			state.searchVisible = show;
		},
		setTab (state, tab) {
			state.currentTab = tab;
		},
		activities (state, activities) {
			state.activities = activities;
		},
		pushLog (state, log) {
			if (state.log.length > 25) {
				state.log.shift();
			}
			state.log.push(log);
		}
	},
	actions: {
		setPOI : (context, poi) => {
			context.commit('setPOI', Object.freeze(poi));
		},
		setGroup : (context, group) => {
			context.commit('setGroup', Object.freeze(group));
		},
		setDefaultGroup : (context, group) => {
			context.commit('setDefaultGroup', Object.freeze(group));
		},
		showSearch : (context, show) => {
			context.commit('showSearch',  show);
		},
		setTab : (context, show) => {
			context.commit('setTab', show);
		},
		pushLog : (context, log) => {
			context.commit('pushLog', log);
		}
	}
})

loadWayfinder(WF_MAP_TYPE, WF_API, loadVue);

function loadVue () {
	new Vue({
		store,
		render: h => h(App),
		created () {
			Vue.use(WayfinderVueComponents, this.$store, WF_MAP_TYPE, WF_PROJECT, WF_API)
		}
	}).$mount('#app')
}
